// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  font-family: Arial, sans-serif;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background-color: #f5f5f5;
}

.switch {
  display: flex;
  align-items: center;
  background: #222;
  border-radius: 25px;
  padding: 4px;
  cursor: pointer;
  position: relative;
  width: 50%;
  overflow: hidden;
  float: inline-end;
  margin-right: 1em;
}

.option {
  flex: 1;
  text-align: center;
  padding: 10px 16px;
  color: white;
  font-size: 18px;
  font-weight: 500;
  transition: color 0.3s;
  position: relative;
  z-index: 2;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
